import { BRAND } from "@/lib/brand";
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "#artists", label: "Artists" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-28 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center group"
        >
          <img
            src={BRAND.logo}
            alt={BRAND.name}
            fetchpriority="high"
            decoding="async"
            className="h-28 w-28 object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-body text-sm tracking-wide text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#quote"
          data-testid="nav-quote-button"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-display font-bold text-sm bg-white text-black hover:bg-brand-magenta hover:text-white transition-all duration-300"
        >
          Request a Quote
        </a>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-lg border border-white/10 text-white"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="font-display font-bold text-lg text-white/90"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              data-testid="nav-mobile-quote-button"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center items-center px-5 py-3 rounded-full font-display font-bold text-sm bg-white text-black"
            >
              Request a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
